/**
 * appConfig.js
 * Centralized config for mobile app promotion.
 * Controls launch state and store URLs.
 */

export const APP_CONFIG = {
    /** App Store / Play Store URLs — empty until launch */
    iosUrl: process.env.REACT_APP_IOS_APP_URL || '',
    androidUrl: process.env.REACT_APP_ANDROID_APP_URL || '',
    webUrl: process.env.REACT_APP_PUBLIC_WEB_URL || 'https://aluvo.app',

    /** Set to true to show the "Report previous question" flag on the quiz page */
    quizReportEnabled: true,
};

/**
 * Detects the visitor's platform.
 * Returns 'ios' | 'android' | 'desktop'
 */
export function detectPlatform() {
    const ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
}

export function isMobileBrowser() {
    const ua = navigator.userAgent || '';
    const platform = detectPlatform();
    if (platform === 'desktop') return false;
    if (/bot|crawl|spider|slurp|facebookexternalhit|twitterbot|linkedinbot|whatsapp/i.test(ua)) return false;
    if (/wv|webview|FBAN|FBAV|Instagram|Line|MicroMessenger/i.test(ua)) return false;
    return true;
}

/**
 * Returns the best CTA href for the current platform + launch state.
 * Returns null if no URL is configured.
 */
export function getAppCtaHref() {
    const platform = detectPlatform();
    if (platform === 'ios') return APP_CONFIG.iosUrl || null;
    if (platform === 'android') return APP_CONFIG.androidUrl || null;
    // Desktop — prefer iOS, fall back to Android
    return APP_CONFIG.iosUrl || APP_CONFIG.androidUrl || null;
}
